import ImageService from '@/services/image.service';
import LearnService from '@/services/learn.service';

import { getField, updateField } from 'vuex-map-fields';
import showToast from '@/util/toast';

const SET_IMAGES = 'SET_IMAGES';
const RESET_IMAGES = 'RESET_IMAGES';
const DELETE_ONE_IMAGE = 'DELETE_ONE_IMAGE';

const SET_PENDING_IMAGES_NUMBER = 'SET_PENDING_IMAGES_NUMBER';
const SET_SUCCESS_IMAGES_NUMBER = 'SET_SUCCESS_IMAGES_NUMBER';
const REMOVE_ERROR_IMAGE = 'REMOVE_ERROR_IMAGE';

/**
 *
 * @param {String} username: username
 * @param {String} skip: number of skip image
 * @param {String} limit: limit of images
 * @returns
 */
const retrieveUploadedImagesBase = async ({ username, skip, limit }) => {
	let retrievedImages = [];

	let response = await ImageService.retrieveAllTrainerImages({ username, skip, limit });
	let items = response.data.data;
	const count = response.data.count;

	if (!items) return;

	for (const element of items) {
		response = await ImageService.getPresignedUrl({
			file_name: element.image_name,
			s3_key: element.s3_key,
		});

		const item = {
			imageId: element._id.$oid,
			imageURI: response.data.link,
			imageType: element.image_type,
			imageName: element.image_name,
			imageKey: element.s3_key,
			dateCreated: element.created_at,
			isLoaded: false,
		};

		retrievedImages.push(item);
	}
	return { retrievedImages, count };
};

export default {
	namespaced: true,
	state() {
		return {
			images: [],
			image: null,
			uploadedImages: [],
			imageContainer: null,

			pendingUploadNumber: 0,
			successUploadNumber: 0,

			numberstep1:false,
			numberstep2:false,
			numberstep3:false
		};
	},

	actions: {
		/**
		 * upload image to server depend on data type
		 * @param {*} param0 : commit
		 * @param {String} username: username
		 * @param {String} skip: number of skip image
		 * @param {String} limit: limit of images
		 */
		async uploadTrainerImages({ commit, state }, payload) {
			commit(SET_PENDING_IMAGES_NUMBER, 1)

			try {
				let formData = new FormData();
				
				formData.append('username', payload.username);
				formData.append('image_type', payload.type.toLowerCase());
				formData.append('content', payload.file);
				formData.append('file_name', payload.fileName);
				
				const response = await ImageService.uploadTrainerImages(formData);
				
				state.images[payload.uploadIdx].imageId = response.data.id;
				state.images[payload.uploadIdx].imageKey = response.data.s3_key;

				commit(SET_SUCCESS_IMAGES_NUMBER, 1);
				
			} catch (error) {
				console.log(error);
				commit(REMOVE_ERROR_IMAGE);
				showToast({
					vueInstance: payload.vueInstance,
					type: "danger",
					message: payload.message
				});
			}
			commit(SET_PENDING_IMAGES_NUMBER, -1);
		},

		/**
		 * retrieve uploaded images from server
		 * @param {*} param0
		 * @param {Object} payload: username
		 */
		async retrieveUploadedImagesInit({ commit, state }, { username, skip, limit }) {
			const { retrievedImages, count } = await retrieveUploadedImagesBase({
				username,
				skip,
				limit,
			});

			commit(SET_IMAGES, retrievedImages);
		},

		/**
		 * delete local images server
		 */
		async deleteLocalImages({ commit, state }, { username }) {
			const response = await ImageService.deleteLocalImages({ username });
			commit(RESET_IMAGES);
			return response.data;
		},

		/**
		 * retrieve uploaded images from server
		 * @param {*} param0
		 * @param {String} username: username
		 * @param {String} skip: number of skip image
		 * @param {String} limit: limit of images
		 */
		async retrieveUploadedImagesPaginated({ commit, state }, { username, skip, limit }) {
			const { retrievedImages, count } = await retrieveUploadedImagesBase({
				username,
				skip,
				limit,
			});

			const tempImages = [...state.images].concat(retrievedImages);
			commit(SET_IMAGES, tempImages);
		},

		/**
		 * delete image from server event handler
		 * @param {Object} param0: commit and state object
		 * @param {Object} payload : username, file_name, s3_key, image_type, id, index
		 */
		async deleteImage({ commit, state }, payload) {
			try {
				let response = await ImageService.deleteTrainerImages({
					username: payload.username,
					file_name: payload.file_name,
					s3_key: payload.s3_key,
					image_type: payload.image_type,
					id: payload.id,
				});
				commit(DELETE_ONE_IMAGE, payload.index)
				commit(SET_SUCCESS_IMAGES_NUMBER, -1)
			} catch (error) {
				console.log(error);
			}

		},

		async startLearn({ commit, state }, payload) {
			const response = await LearnService.startLearning(payload)
			console.log('start learn response', response);
			return response;
		},
		resetTrainerImages({ commit }) {
			commit(RESET_IMAGES);
		},
	},

	mutations: {
		updateField,
		SET_IMAGES(state, payload) {
			state.images = payload;
		},

		PUSH_IMAGE(state, payload) {
			state.images.push(payload.image);
		},

		SET_IMAGE(state, payload) {
			state.image = payload;
		},

		DELETE_ONE_IMAGE(state, payload) {
			let deleteIdx = state.images.length - 1 - payload;
			state.images.splice(deleteIdx, 1);
		},

		SET_PENDING_IMAGES_NUMBER(state, payload) {
			state.pendingUploadNumber += payload
		},

		SET_SUCCESS_IMAGES_NUMBER(state, payload) {
			state.successUploadNumber += payload
		},

		REMOVE_ERROR_IMAGE(state) {
			state.images.pop()
		},

		UPDATE_UPLOADED_IMAGES(state, payload) {
			state.uploadedImages = payload;
		},

		RESET_IMAGES(state) {
			state.images = [];
			state.pendingUploadNumber = 0;
			state.successUploadNumber = 0;
		},


		SET_STEP1(state){
			state.numberstep1=true
			state.numberstep2 = false
			state.numberstep3 = false
		},
		
		SET_STEP2(state){
			state.numberstep1= false
			state.numberstep2 = true
			state.numberstep3 = false
		},
		
		SET_STEP3(state){
			state.numberstep1= false
			state.numberstep2 = false
			state.numberstep3 = true
		},
	},

	getters: {
		getField,

		totalImageNumber(state) {
			return state.pendingUploadNumber + state.successUploadNumber;
		},

		imagesReactiveLength(state) {
			return state.images.length - 1;
		},

		reversedImages(state) {
			const newArr = [...state.images];
			return newArr.reverse();
		},
		

		// /**
		//  * get train type images
		//  * @param {Object} state
		//  * @returns {Array} array of train type images
		//  */
		// trainTypeImages(state) {
		// 	return state.images.filter((image) => image.imageType === 'train');
		// },

		/**
		 * get validation type images array
		 * @param {Object} state
		 * @returns {Array} array of validation type images
		 */
		validationTypeImages(state) {
			return state.images.filter((image) => image.imageType === 'validation');
		},
	},
};